import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnboardingFacade } from '@zero/onboarding/domain';
import { ButtonComponent, CopyToClipboardComponent, IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { environment } from 'environments/environment';
import { filter, map } from 'rxjs';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [
    OnboardingContainerComponent,
    TranslocoPipe,
    CopyToClipboardComponent,
    ButtonComponent,
    IconComponent,
    AsyncPipe,
    ModalComponent,
  ],
  templateUrl: './ident.component.html',
  styleUrl: './ident.component.scss',
})
export class IdentComponent {
  public readonly facade = inject(OnboardingFacade);
  public readonly modalService = inject(NgbModal);

  readonly #postIdentUrl = environment.isTest
    ? 'https://postident-itu.deutschepost.de/user/start'
    : 'https://postident.deutschepost.de/user/start';

  public readonly processNumber$ = this.facade.onboardingData$.pipe(
    filter((data) => !!data),
    map(({ identificationId }) => identificationId),
  );

  public readonly videoIdentUrl$ = this.processNumber$.pipe(
    map((processNumber) => `${this.#postIdentUrl}/video?caseId=${processNumber}&lang=de`),
  );

  public readonly ePersoUrl$ = this.processNumber$.pipe(
    map((processNumber) => `${this.#postIdentUrl}/eid?caseId=${processNumber}&lang=de`),
  );

  public readonly postOfficeUrl$ = this.processNumber$.pipe(
    map((processNumber) => `${this.#postIdentUrl}/basic?caseId=${processNumber}&lang=de`),
  );
}
